import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Logout from '@mui/icons-material/Logout';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import {
  Box,
  Divider,
  IconButton,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../modules/users';
import CustomAvatar from '../elements/CustomAvatar';
import { tokens } from '../../mui-theme';
import { useUser } from '../../context/UserContext';

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { currentUser, clearUserData } = useUser();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const logoutUser = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('API logout failed for super-admin:', error);
    } finally {
      clearUserData();
      navigate('/login', { replace: true });
    }
  };

  const accountMenuItems = [
    {
      label: 'Account Settings',
      icon: <ManageAccountsOutlinedIcon fontSize="small" />,
      href: '/account-settings',
    },
    {
      label: 'Release Notes',
      icon: <NewReleasesOutlinedIcon fontSize="small" />,
      href: '/updates',
    },
  ];

  const superAdminAccountMenu = [
    {
      label: 'Account Settings',
      icon: <AccountBoxIcon fontSize="small" />,
      href: '/account-settings',
    },
  ];

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          onClick={handleClick}
          size="small"
          disableRipple
          sx={{
            borderRadius: '8px',
            p: '4px',
            transition: 'background 0.15s',
          }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}>
          <CustomAvatar
            firstName={currentUser?.first_name}
            lastName={currentUser?.last_name}
            showTitle={false}
            size={32}
          />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            mt: 0.5,
            minWidth: 210,
            borderRadius: '10px',
            border: `1px solid ${tokens.colors.primary[50]}`,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
          <Typography variant="subtitle2" fontWeight={600} noWrap>
            {currentUser?.first_name} {currentUser?.last_name}
          </Typography>
          <Typography variant="caption" color="text.secondary" noWrap>
            {currentUser?.email}
          </Typography>
        </Box>

        <Divider sx={{ mb: 0.5 }} />

        {(currentUser?.role === 'super-admin'
          ? superAdminAccountMenu
          : accountMenuItems
        ).map((item) => (
          <Link
            key={item.href}
            underline="none"
            color="inherit"
            href={item.href}>
            <MenuItem
              onClick={handleClose}
              sx={{
                mx: 0.5,
                borderRadius: '6px',
                fontSize: '0.875rem',
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
              }}>
              <ListItemIcon sx={{ minWidth: 34 }}>{item.icon}</ListItemIcon>
              {item.label}
            </MenuItem>
          </Link>
        ))}

        <Divider sx={{ my: 0.5 }} />

        <MenuItem
          onClick={logoutUser}
          sx={{
            mx: 0.5,
            borderRadius: '6px',
            fontSize: '0.875rem',
            color: 'error.main',
            '&:hover': { backgroundColor: 'rgba(211,47,47,0.06)' },
          }}>
          <ListItemIcon sx={{ minWidth: 34 }}>
            <Logout fontSize="small" sx={{ color: 'error.main' }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}